import { pubSub } from '@utils/PubSub';

export default class VisualCategory {
  constructor(context) {
    const parent = context.parentElement;
    const containsClass = parent.classList.contains(
      'commercial-module-spacing'
    );
    const isTest = context.classList.contains('visual-category--dy-ab-test');
    const isControl = context.classList.contains(
      'visual-category--dy-ab-test-control'
    );

    if (isTest && isControl) {
      this.watchAbTest(context);
    }

    if (!containsClass) {
      parent.classList.add('commercial-module-spacing');
    }
  }

  /**
   * DY reveals the assigned variant with CSS and announces itself with
   * `dy:visual:category:test`. If that event never arrives (no consent,
   * blocked, slow), show the control so the module still renders.
   * @param {HTMLElement} context - The control variant's module element.
   */
  watchAbTest(context) {
    const event = 'dy:visual:category:test';
    const onDyLoaded = () => pubSub.unsubscribe(event, onDyLoaded);
    const showControl = () => {
      context.style.display = 'block';
    };

    pubSub.subscribe(event, onDyLoaded, showControl);
  }
}
